import { LoginView } from '@pages/Auth';
import { createFileRoute } from '@tanstack/react-router';

interface LoginSearch {
  redirect?: string;
}

export const Route = createFileRoute('/_app/__not-auth/login')({
  component: LoginView,
  validateSearch: (
    search: Record<string, unknown>,
  ): LoginSearch | undefined => {
    if (typeof search.redirect === 'string') {
      return { redirect: search.redirect };
    }

    return undefined;
  },
});
